import { FC, useEffect, useState } from "react";
import ActionMenuBox from "components/menu/action-menu/ActionMenuBox";
import ActionMenuItem from "components/menu/action-menu/ActionMenuItem";
import { MenuComponent } from "assets/ts/components";
import { useTranslation } from "react-i18next";
import Button from "components/base/button/Button";
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import RoleDelete from "./RoleDelete";
import { useFeatureAccess } from "hooks‬/custome-hooks/useFeatureAccess";
import { featureObject } from "helpers/privileges/utils";
import { useAuth } from "hooks‬/Auth";
import ButtonTooltip from "components/base/ButtonTooltip";

interface TypesOfProps {
  role: any;
  setShowCreateRolePopup: any;
  setIsUpdateRole: any;
  setIsCloneRole: any;
  setSelectedRole: any;
  fetchAPI: any;
}

const MenuTrigger = ({
  cloneRoleHandler,
  deleteHandler,
  isMasterRole = false,
}: {
  cloneRoleHandler: () => void;
  deleteHandler: () => void;
  isMasterRole?: boolean;
}) => {
  const { t } = useTranslation();
  const { isReadOnlyFeature, featureLimitStatus, companySubscriptionDetails } =
    useAuth();
  const rolesAccess = useFeatureAccess(featureObject.USR_ROLE);

  return (
    <ActionMenuBox>
      {rolesAccess.canModify && (
        <ButtonTooltip
          title={
            companySubscriptionDetails?.isExpired
              ? "You do not have active subscription to access this feature."
              : "Role limit exceeded. Upgrade your plan to add more roles."
          }
          isShow={isReadOnlyFeature(
            featureLimitStatus?.IS_CUSTOM_ROLE_CREATION_EXCEED
          )}
        >
          <ActionMenuItem
            title={t("Clone")}
            onClickAction={() => {
              if (!featureLimitStatus?.IS_CUSTOM_ROLE_CREATION_EXCEED && !companySubscriptionDetails?.isExpired )
                cloneRoleHandler();
            }}
          />
        </ButtonTooltip>
      )}
      {!isMasterRole && rolesAccess.canDelete && (
        <ActionMenuItem
          title={t("DELETE")}
          onClickAction={() => {
            deleteHandler();
          }}
        />
      )}
    </ActionMenuBox>
  );
};

const RoleCard: FC<TypesOfProps> = ({
  role,
  setSelectedRole,
  setIsUpdateRole,
  setIsCloneRole,
  setShowCreateRolePopup,
  fetchAPI,
}) => {
  const { t } = useTranslation();
  const rolesAccess = useFeatureAccess(featureObject.USR_ROLE);
  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);
  const { companySubscriptionDetails } = useAuth();
  const navigate = useNavigate();
  const [showDeleteRolePopup, setShowDeleteRolePopup] = useState(false);

  const closeShowDeleteRolePopupHandler = () => {
    setShowDeleteRolePopup(false);
  };
  return (
    <div className="card border  d-flex flex-column justify-content-between align-self-stretch h-100  p-10">
      <div>
        <div className="  border-muted d-flex justify-content-between align-items-start mb-2">
          <h1 className="text-gray-700">
            {role.displayName}{" "}
            {role.masterRole && (
              <span className="badge badge-light-primary ">Default</span>
            )}
          </h1>
          {(rolesAccess.canModify || rolesAccess.canDelete) &&
            companySubscriptionDetails && (
              <div>
                <div
                  className="btn btn-secondary btn-active-light btn-sm m-1 rounded p-2"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <BsThreeDots />
                </div>
                <MenuTrigger
                  isMasterRole={role.masterRole}
                  deleteHandler={() => setShowDeleteRolePopup(true)}
                  cloneRoleHandler={() => {
                    setSelectedRole({
                      value: role.guid,
                      label: role.displayName,
                    });
                    setIsUpdateRole(false);
                    setIsCloneRole(true);
                    setShowCreateRolePopup();
                  }}
                />
              </div>
            )}
        </div>
        <div className="text-start text-gray-800 fs-3 mt-5">
          {t("messages:USER.WITH.ROLE")} {role.userCount ?? "0"}
        </div>
        <div className="m-0">
          <ul className="feature-list text-gray-600 p-5 m-0">
            {role.description.map((desc: string, index: number) =>
              index < 5 ? (
                <li className="mb-2 fs-6 me-2" key={desc}>
                  {desc}
                </li>
              ) : null
            )}
          </ul>
        </div>
      </div>
      <div className="d-flex flex-md-row flex-column  align-items-start justify-content-start pt-5">
        {rolesAccess.canRead && (
          <Button
            className="btn btn-primary btn-sm m-1 "
            onClick={() => {
              navigate("/user-management/roles/" + role.guid);
            }}
          >
            <span className="indicator-label text-capitalize">
              {t("VIEW.ROLE")}
            </span>
          </Button>
        )}
        {rolesAccess.canModify && !role.masterRole && (
          <div>
            <button
              onClick={() => {
                setSelectedRole({
                  value: role.guid,
                  label: role.displayName,
                });
                setIsUpdateRole(true);
                setIsCloneRole(false);
                setShowCreateRolePopup();
              }}
              className="btn btn-secondary btn-active-light btn-sm m-1"
            >
              {t("Edit Role")}
            </button>
          </div>
        )}
      </div>
      <RoleDelete
        showModal={showDeleteRolePopup}
        closeModal={closeShowDeleteRolePopupHandler}
        fetchAPI={fetchAPI}
        role={role}
      />
    </div>
  );
};
export default RoleCard;
